import { CasButton } from 'src/compass/shared/components';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';
import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatus } from './ClaimListing';
import UnbatchedAttachedDialog from './UnbatchedAttachedDialog';

export default function DocusignReviewTab() {
  const dialog = useCasBoolean();

  return (
    <>
      <ClaimListing
        columns={[
          ClaimColumns.insuredName,
          ClaimColumns.reinsuranceYear,
          ClaimColumns.policyNumber,
          ClaimColumns.sce,
          ClaimColumns.whatSent,
        ]}
        filters={[ClaimFilters.insuredNameSearch]}
        additionalPayload={{
          status: ClaimStatus.DocusignReview,
        }}
        toolbarButtons={[
          <CasButton key="hudson-email" onClick={dialog.setTrue}>
            Hudson Email Batch
          </CasButton>,
        ]}
        columnsSortable={false}
        includeExport={false}
      />
      {dialog.value && <UnbatchedAttachedDialog onClose={dialog.setFalse} />}
    </>
  );
}
